"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetStarted() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section ref={sectionRef} className="py-16 sm:py-20 lg:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className={`space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
              Ready to unlock your unfair advantage?
            </h2>
            <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed">
              Join the elite investors and businesses who leverage Nethill Limited's proven methodology to dominate Nigerian real estate and digital markets.
            </p>
          </div>

          {}
          <div className={`flex justify-start lg:justify-end transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Link to="#contact" className="inline-block">
              <Button size="lg" className="bg-secondary text-foreground-secondary hover:bg-secondary-hover active:bg-secondary-active shadow-medium px-8 py-6 text-lg font-semibold rounded-md transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-[1.03] hover:shadow-strong focus-visible:ring-secondary/40">
                Get Started Today
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}